import { Injectable } from '@angular/core';
import { CommonService } from '@geneplanet/ngx-shop/src/lib/shared';
import {
  Location,
  LocationCode,
} from '@geneplanet/ngx-utils/src/lib/localization';
import { CustomLocalizeRouterService } from 'src/app/core/services/custom-localize-router.service';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable } from 'rxjs';
import { COOKIE_DOMAIN, COOKIE_LANG } from 'src/app/app.constants';
import { setLocaleData } from 'src/app/app.utils';
import { environment } from 'src/environments/environment';
import { AnalyticsService } from '@geneplanet/ngx-utils';
import { AncestryService } from 'src/app/ancestry/services/ancestry.service';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  currentLocation$ = new BehaviorSubject<Location>(null);

  get locationCode(): LocationCode {
    return this.currentLocation$.value.code;
  }

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private localize: CustomLocalizeRouterService,
    private cookieService: CookieService,
    private ancestryService: AncestryService,
    private analyticsService: AnalyticsService
  ) {}

  onLocationChange(location: Location): void {
    if (environment.rudderStackEnabled) {
      this.analyticsService.locale =
        location.lang.code + '-' + location.code.toUpperCase();
    }
    const expirationDate = new Date(
      new Date().setFullYear(new Date().getFullYear() + 1)
    );

    this.cookieService.set(
      COOKIE_LANG,
      location.code,
      expirationDate,
      '/',
      `${COOKIE_DOMAIN}`
    );

    this.currentLocation$.next(location);
    setLocaleData(location.code);
    this.commonService.setCurrency(location.currency);
    this.commonService.setPartnerId(location.partner.id);

    this.localize.parser.defaultLang = location.code;
    this.localize.changeLanguageWithoutNavigation(location.code);

    this.ancestryService.cleanup();
  }

  getLocations() {
    return environment.locations;
  }

  public updateLocaleOnServer(location: Location): Observable<void> {
    const data = {
      language: location.lang.longCode,
      languageCode: location.lang.code,
      locationCode: location.code,
    };
    return this.http.put<void>('/api/customers/locale', data);
  }
}
